import { Admin2, audit } from "assets/icons";
import {
  admins,
  dashIcon,
  institutions,
  logo2,
  logout,
  //nav,
  transactions,
} from "assets/icons";
import { UP } from "assets/images";
import { AppButton, AppModal, AppPasswordInput } from "components";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { ApiService } from "services";
import styled from "styled-components";
import { userData } from "utils/userData";

export default function Navbar({ closeState, setCloseState }) {
  //const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);

  //eslint-disable-next-line
  const [dashboardMetric, setDashboardMetric] = useState("");

  const links = (userData?.userDetail?.role === "chiefAdmin" && [
    {
      name: "Dashboard",
      url: "/dashboard",
      param: "",
      icon: dashIcon,
      miniLinks: [
        { name: "Response Time", path: "/response-time", param: "" },
        { name: "Approval Rate", path: "/approval-rate", param: "" },
        { name: "Transaction Report", path: "/transaction-report", param: "" },
        { name: "Today's Transactions", path: "/today-transaction", param: "" },
        {
          name: "Institution Performance",
          path: "/institution-performance",
          param: "",
        },
        {
          name: "Transaction Performance",
          path: "/transaction-performance",
          param: "",
        },
      ],
    },
    {
      name: "Admins",
      url: "/sub-admins",
      param: "?tab=subAdmin1",
      icon: admins,
    },
    {
      name: "Institutions",
      url: "/institutions",
      param: "?tab=bank",
      icon: institutions,
    },
    {
      name: "Current Month Transactions",
      url: "/transactions",
      param: "",
      icon: transactions,
    },
    {
      name: "Transactions Archive",
      url: "/transactions-db",
      param: "",
      icon: transactions,
    },
    {
      name: "Audit Trail",
      url: "/audit-trail",
      param: "",
      icon: audit,
    },
    {
      name: "Configurations",
      url: "/configurations",
      param: "",
      icon: audit,
    },
    {
      name: "Balance Configuration",
      url: "/balance-configuration",
      param: "",
      icon: audit,
    },
  ]) ||
    (userData?.userDetail?.role === "subAdmin1" && [
      {
        name: "Dashboard",
        url: "/dashboard",
        param: "",
        icon: dashIcon,
        miniLinks: [
          { name: "Response Time", path: "/response-time", param: "" },
          { name: "Approval Rate", path: "/approval-rate", param: "" },
          {
            name: "Transaction Report",
            path: "/transaction-report",
            param: "",
          },
          {
            name: "Today's Transactions",
            path: "/today-transaction",
            param: "",
          },
          {
            name: "Institution Performance",
            path: "/institution-performance",
            param: "",
          },
          {
            name: "Transaction Performance",
            path: "/transaction-performance",
            param: "",
          },
        ],
      },
      {
        name: "Admins",
        url: "/sub-admins",
        param: "?tab=subAdmin1",
        icon: admins,
      },
      {
        name: "Institutions",
        url: "/institutions",
        param: "?tab=bank",
        icon: institutions,
      },
      {
        name: "Current Month Transactions",
        url: "/transactions",
        param: "",
        icon: transactions,
      },
      {
        name: "Transactions Archive",
        url: "/transactions-db",
        param: "",
        icon: transactions,
      },
    ]) ||
    (userData?.userDetail?.role === "subAdmin2" && [
      {
        name: "Dashboard",
        url: "/dashboard",
        param: "",
        icon: dashIcon,
        miniLinks: [
          { name: "Response Time", path: "/response-time", param: "" },
          { name: "Approval Rate", path: "/approval-rate", param: "" },
          {
            name: "Transaction Report",
            path: "/transaction-report",
            param: "",
          },
          {
            name: "Today's Transactions",
            path: "/today-transaction",
            param: "",
          },
          {
            name: "Institution Performance",
            path: "/institution-performance",
            param: "",
          },
          {
            name: "Transaction Performance",
            path: "/transaction-performance",
            param: "",
          },
        ],
      },
      {
        name: "Admins",
        url: "/sub-admins",
        param: "?tab=subAdmin1",
        icon: admins,
      },
      {
        name: "Institutions",
        url: "/institutions",
        param: "?tab=bank",
        icon: institutions,
      },
      {
        name: "Current Month Transactions",
        url: "/transactions",
        param: "",
        icon: transactions,
      },
      {
        name: "Transactions Archive",
        url: "/transactions-db",
        param: "",
        icon: transactions,
      },
    ]) ||
    (userData?.userDetail?.role === "bankAdmin" && [
      {
        name: "Dashboard",
        url: "/dashboard",
        param: "",
        icon: dashIcon,
      },
      {
        name: "Bank User",
        url: "/bank-user",
        param: "?tab=bankUser1",
        icon: admins,
      },

      {
        name: "Current Month Transactions",
        url: "/transactions",
        param: "",
        icon: transactions,
      },
      {
        name: "Transactions Archive",
        url: "/transactions-db",
        param: "",
        icon: transactions,
      },
    ]) ||
    (userData?.userDetail?.role === "nonBankAdmin" && [
      {
        name: "Dashboard",
        url: "/dashboard",
        param: "",
        icon: dashIcon,
      },
      {
        name: "Non Bank User",
        url: "/non-bank-user",
        param: "?tab=nonBankUser1",
        icon: admins,
      },

      {
        name: "Current Month Transactions",
        url: "/transactions",
        param: "",
        icon: transactions,
      },
      {
        name: "Transactions Archive",
        url: "/transactions-db",
        param: "",
        icon: transactions,
      },
    ]) || [
      {
        name: "Dashboard",
        url: "/dashboard",
        param: "",
        icon: dashIcon,
      },

      {
        name: "Current Month Transactions",
        url: "/transactions",
        param: "",
        icon: transactions,
      },
      {
        name: "Transactions Archive",
        url: "/transactions-db",
        param: "",
        icon: transactions,
      },
    ];

  const [oldPassword, setOldPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [loader, setLoader] = useState(false);

  const changePassword = async () => {
    if (newPassword === confirmPassword) {
      setLoader(true);
      try {
        const data = await ApiService.changePassword({
          userId: localStorage.getItem("user_id"),
          oldPassword: oldPassword,
          newPassword: newPassword,
          confirmPassword: confirmPassword,
        });
        console.log(data);
        setLoader(false);
        setModal2(false);
        toast.success(data?.message);
      } catch (err) {
        console.log(err);
        setLoader(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    } else {
      toast.error("New Passwords have to match");
    }
  };

  console.log(window.location.search);
  //const closeR = JSON.parse(localStorage.getItem("close"));
  useEffect(() => {
    //localStorage.setItem("close", false);
    //eslint-disable-next-line
  }, []);
  const [showLinks, setShowLinks] = useState(false);

  const router = useNavigate();

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <NavbarStyle>
        <div className="nav_body">
          {/*   <div
            style={{
              position: "absolute",
              top: "30px",
              right: !closeState ? "30px" : "0",
              transform: closeState && "translateX(50%)",
              cursor: "pointer",
              background: "#FFF",
              padding: "2px 2px 0px 2px",
              borderRadius: "10000px",
              zIndex: "10",
            }}
            onClick={() => {
              setCloseState(!closeState);
              localStorage.setItem("close", closeState);
              //navigate(window.location.pathname);
            }}
          >
            <img src={nav} alt="" />
          </div> */}
          {!closeState && <img className="logo" src={logo2} alt="" />}
          <div className="nav_links">
            {links?.slice(0, 1)?.map((item) => {
              return (
                <>
                  <div
                    onClick={() => {
                      router(item?.url + item?.param);
                    }}
                    className={
                      window.location.pathname === "/dashboard" ||
                      window.location.pathname === "/response-time" ||
                      window.location.pathname === "/approval-rate" ||
                      window.location.pathname === "/transaction-report" ||
                      window.location.pathname === "/today-transaction" ||
                      window.location.pathname === "/institution-performance" ||
                      window.location.pathname === "/transaction-performance"
                        ? "nav_link active dash"
                        : "nav_link dash"
                    }
                  >
                    <di className="nav_link_inner">
                      <img src={item?.icon} alt="" />
                      {!closeState && <p>{item?.name}</p>}
                    </di>
                    <svg
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowLinks(!showLinks);
                      }}
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 5.0498L8 11.0498L14 5.0498"
                        stroke="white"
                        stroke-width="2.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>

                  {showLinks && (
                    <>
                      {showLinks ||
                      window.location.pathname === "/dashboard" ||
                      window.location.pathname === "/response-time" ||
                      window.location.pathname === "/approval-rate" ||
                      window.location.pathname === "/transaction-report" ||
                      window.location.pathname === "/today-transaction" ||
                      window.location.pathname === "/institution-performance" ||
                      window.location.pathname ===
                        "/transaction-performance" ? (
                        <div>
                          {item?.miniLinks?.map((link) => {
                            return (
                              <Link to={link?.path + link?.param}>
                                <div
                                  onClick={() => {
                                    setDashboardMetric(link?.path);
                                    localStorage.setItem(
                                      "dashboardMetric",
                                      link?.path
                                    );
                                  }}
                                  style={{ marginLeft: "10px" }}
                                  className={
                                    window.location.pathname === link?.path
                                      ? "nav_link active"
                                      : "nav_link"
                                  }
                                >
                                  {!closeState && <p>{link?.name}</p>}
                                </div>
                              </Link>
                            );
                          })}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </>
              );
            })}

            {links?.slice(1, 10)?.map((item) => {
              return (
                <>
                  <Link to={item?.url + item?.param}>
                    <div
                      className={
                        window.location.pathname === item?.url
                          ? "nav_link active"
                          : "nav_link"
                      }
                    >
                      <img src={item?.icon} alt="" />
                      {!closeState && <p>{item?.name}</p>}
                    </div>
                  </Link>
                  {item?.miniLinks?.map((link) => {
                    return (
                      <Link to={link?.path + link?.param}>
                        <div
                          onClick={() => {
                            setDashboardMetric(link?.path);
                            localStorage.setItem("dashboardMetric", link?.path);
                          }}
                          style={{ marginLeft: "10px" }}
                          className={
                            window.location.pathname === link?.path
                              ? "nav_link active"
                              : "nav_link"
                          }
                        >
                          {!closeState && <p>{link?.name}</p>}
                        </div>
                      </Link>
                    );
                  })}
                </>
              );
            })}
            <div
              onClick={() => {
                setModal2(true);
              }}
              className="nav_link"
            >
              <img
                style={{ width: "28px", borderRadius: "1000px" }}
                src={Admin2}
                alt=""
              />
              {!closeState && <p>Change Password</p>}
            </div>

            <div
              onClick={() => {
                setModal(true);
              }}
              className="nav_link"
            >
              <img src={logout} alt="" />
              {!closeState && <p>Logout</p>}
            </div>
          </div>

          {userData?.userDetail?.role === "chiefAdmin" && (
            <div
              style={{
                marginTop: "10%",
                background: "white",
                padding: "20px",
                borderRadius: "1000000px",
                width: !closeState ? "40px" : "18px",
                height: !closeState ? "40px" : "18px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
                src={UP}
                alt=""
              />
            </div>
          )}

          {userData?.userDetail?.role === "subAdmin1" && (
            <div
              style={{
                marginTop: "10%",
                background: "white",
                padding: "20px",
                borderRadius: "1000000px",
                width: !closeState ? "40px" : "18px",
                height: !closeState ? "40px" : "18px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
                src={UP}
                alt=""
              />
            </div>
          )}

          {userData?.userDetail?.role === "subAdmin2" && (
            <div
              style={{
                marginTop: "10%",
                background: "white",
                padding: "20px",
                borderRadius: "1000000px",
                width: !closeState ? "40px" : "18px",
                height: !closeState ? "40px" : "18px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
                src={UP}
                alt=""
              />
            </div>
          )}
          {userData?.userDetail?.role === "bankAdmin" && (
            <div
              style={{
                marginTop: "10%",
                background: "white",
                padding: "20px",
                borderRadius: "1000000px",
                width: !closeState ? "40px" : "18px",
                height: !closeState ? "40px" : "18px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
                src={userData?.userDetail?.institution?.logo?.url}
                alt=""
              />
            </div>
          )}

          {userData?.userDetail?.role === "nonBankAdmin" && (
            <div
              style={{
                marginTop: "10%",
                background: "white",
                padding: "20px",
                borderRadius: "1000000px",
                width: !closeState ? "40px" : "18px",
                height: !closeState ? "40px" : "18px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
                src={userData?.userDetail?.institution?.logo?.url}
                alt=""
              />
            </div>
          )}

          {userData?.userDetail?.role === "bankUser1" && (
            <div
              style={{
                marginTop: "10%",
                background: "white",
                padding: "20px",
                borderRadius: "1000000px",
                width: !closeState ? "40px" : "18px",
                height: !closeState ? "40px" : "18px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
                src={userData?.userDetail?.institution?.logo?.url}
                alt=""
              />
            </div>
          )}

          {userData?.userDetail?.role === "bankUser2" && (
            <div
              style={{
                marginTop: "10%",
                background: "white",
                padding: "20px",
                borderRadius: "1000000px",
                width: !closeState ? "40px" : "18px",
                height: !closeState ? "40px" : "18px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
                src={userData?.userDetail?.institution?.logo?.url}
                alt=""
              />
            </div>
          )}

          {userData?.userDetail?.role === "nonBankUser1" && (
            <div
              style={{
                marginTop: "10%",
                background: "white",
                padding: "20px",
                borderRadius: "1000000px",
                width: !closeState ? "40px" : "18px",
                height: !closeState ? "40px" : "18px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
                src={userData?.userDetail?.institution?.logo?.url}
                alt=""
              />
            </div>
          )}
          {userData?.userDetail?.role === "nonBankUser2" && (
            <div
              style={{
                marginTop: "10%",
                background: "white",
                padding: "20px",
                borderRadius: "1000000px",
                width: !closeState ? "40px" : "18px",
                height: !closeState ? "40px" : "18px",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
                src={userData?.userDetail?.institution?.logo?.url}
                alt=""
              />
            </div>
          )}
          {!closeState && (
            <>
              <h3 style={{ color: "white" }}>
                {userData?.firstName} {userData?.lastName}
              </h3>
              <p style={{ color: "white", textTransform: "capitalize" }}>
                <span style={{ color: "white", textTransform: "capitalize" }}>
                  {userData?.userDetail?.role}
                </span>
              </p>
            </>
          )}
        </div>
        {modal && (
          <AppModal
            closeModal={() => {
              setModal(false);
            }}
          >
            <div>
              <svg
                width="62"
                height="63"
                viewBox="0 0 62 63"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  opacity="0.2"
                  y="0.5"
                  width="62"
                  height="62"
                  rx="31"
                  fill="#FF7A00"
                />
                <path
                  d="M44.9274 21.5259L31.7924 14.9362C31.5639 14.8207 31.3116 14.7603 31.0556 14.7598C30.7996 14.7592 30.547 14.8185 30.318 14.9329L17.0941 21.5226C16.6048 21.7697 16.2671 22.2425 16.1979 22.7862C16.1765 22.946 14.3116 38.8338 30.2686 47.5108C30.5139 47.6445 30.7893 47.7134 31.0687 47.7108C31.3481 47.7082 31.6222 47.6343 31.8649 47.4959C47.1975 38.8321 45.8911 23.488 45.8285 22.8389C45.8015 22.5617 45.7047 22.2959 45.5471 22.0663C45.3895 21.8366 45.1763 21.6507 44.9274 21.5259Z"
                  fill="#FF7A00"
                />
                <path
                  d="M29.039 19.7197H32.2778V27.4283L31.8567 35.8799H29.46L29.039 27.4283V19.7197ZM28.5208 40.5855C28.5208 39.9457 28.7043 39.4401 29.0713 39.0686C29.46 38.6971 29.9998 38.5113 30.6908 38.5113C31.2521 38.5113 31.7488 38.7177 32.1806 39.1305C32.634 39.5433 32.8608 40.0283 32.8608 40.5855C32.8608 41.2047 32.6556 41.7103 32.2454 42.1025C31.8351 42.474 31.3169 42.6597 30.6908 42.6597C30.1078 42.6597 29.6004 42.4533 29.1685 42.0406C28.7367 41.6278 28.5208 41.1428 28.5208 40.5855Z"
                  fill="white"
                />
              </svg>

              <h3>Confirm Logout</h3>
            </div>
            <div style={{ display: "flex" }}>
              <AppButton
                onClick={() => {
                  setModal(false);
                }}
                outline
                placeholder="Cancel"
              />
              &nbsp; &nbsp; &nbsp; &nbsp;
              <AppButton
                color="#FF7A00"
                onClick={() => {
                  localStorage.clear();
                  window.location = "/";
                }}
                placeholder="Confirm"
              />
            </div>
          </AppModal>
        )}

        {modal2 && (
          <AppModal
            heading="Change Password"
            closeModal={() => {
              setModal2(false);
            }}
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
                changePassword();
              }}
            >
              <br></br>
              <AppPasswordInput
                onChange={(e) => {
                  setOldPassword(e.target.value);
                }}
                placeholder="Enter Old Password"
                background="#f5f5f5"
              />
              <AppPasswordInput
                onChange={(e) => {
                  setNewPassword(e.target.value);
                }}
                placeholder="Enter New Password"
                background="#f5f5f5"
              />
              <AppPasswordInput
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                }}
                placeholder="Confirm New Password"
                background="#f5f5f5"
              />

              <AppButton
                loading={loader}
                disabled={loader}
                placeholder="Proceed"
              />
            </form>
          </AppModal>
        )}
      </NavbarStyle>
    </div>
  );
}

const NavbarStyle = styled.div`
  background-color: #04a3e5;
  border-radius: 0px 20px 0px 0px;
  height: 100vh;
  overflow: hidden;
  overflow-y: scroll;
  .logo {
    margin-top: 70px;
  }
  a {
    text-decoration: none;
    color: white;
  }

  &::-webkit-scrollbar {
    width: 0;
  }

  .nav_body {
    padding: 30px;
    position: relative;
  }

  .nav_links {
    margin-top: 70px;
    border-bottom: 1px solid white;

    .nav_link {
      display: flex;
      align-items: center;
      padding: 6px 12px;
      border-radius: 10px;
      margin-bottom: 10px;
      cursor: pointer;

      p {
        font-size: 14px;
        margin-left: 10px;
        color: white;
      }
    }
    .nav_link_inner {
      display: flex;
      align-items: center;
    }
    .nav_link.active {
      background: #ff993a;
    }
    .nav_link.dash {
      justify-content: space-between;
    }
  }
`;
